module.exports = __webpack_public_path__ + "assets/img/logo.6a11be25.png";